import "./ProductTopBar.scss";

export { default } from "app/pages/Listing/Product/ProductTopBar/ProductTopBar.jsx";
